// TODO: some of these messages or errors are not used
// either modify the code to use them or remove them

const RETRY_OR_EMAIL = 'Try again, and if the issue persists, contact support at it@actionstation.org.nz.'

const messages = {
  // generic error
  ERROR: `
  Apologies, we had an error in our system. The page will be refreshed. ${RETRY_OR_EMAIL}
  `,

  ERROR_SELECT_INCREASE: 'Please select one of the amounts to increase your donation.',

  ERROR_AUTH: `
  Apologies, there was an error when logging you in. ${RETRY_OR_EMAIL}
  `,

  ERROR_STRIPE_ZERO_SUBSCRIPTION: (donation_link) => `
  We did not find any regular donations tied to your account.
  <a target="_donate" href="${donation_link}"><strong>I want to donate</strong></a>.
  `,

  ERROR_STRIPE_MULTIPLE_SUBSCRIPTION: `
  We found multiple donation accounts tied to your email and need to fix this
  manually before you can continue. Please write to it@actionstation.org.nz
  with the best time, date and phone number to contact you.
  `,

  MAINTENANCE_MODE: `
  We are updating or fixing this application. Some features might not work.
  Please try again in a few hours or contact it@actionstation.org.nz
  `,

  ACCOUNT_RELOADING: '<p class="text-center mt-3 mb-3">Reloading your account</p>',

  REGULAR_DONATION: (amount, period) => `
  Thanks! Your donation is <strong>$${amount}</strong> a ${period}.
  `,

  REGULAR_DONATION_UPDATE_CONFIRM: (name, period, amount) => `
    Just to confirm: you are ${name} updating your ${period} donation to $${amount}?
  `,

  REGULAR_DONATION_UPDATING: 'Updating your donation, please wait a few seconds.',

  REGULAR_DONATION_UPDATED: `
  Your donation has been updated! Thank you for your generous and ongoing support.
  `,
  CANCEL_DONATION_CONFIRM: (name, period, amount) =>`
   Just to confirm: you are ${name} canceling your ${period} donation of $${amount}?
  `,
  CANCEL_DONATION_UPDATING: 'Cancelling your donation, please wait a few seconds.',
  CANCEL_DONATION_UPDATED: `
    Your donation has been cancelled. Thank you for your support!
  `
}

export const get_message = (key, ...params) => {
  if(!messages[key]) {
    return key
  }

  if(typeof messages[key] === 'function') {
    return messages[key](...params)
  }

  return messages[key]
}
